export default __webpack_public_path__ + "static/media/bmrcl.b139e285.webp";